<template>
    <div class="bg_main">
        <div class="banner-wrap">
            <div class="msg-list color_fff">
                <div class="fs14 flex jcb">
                    <span>即将开课</span>
                    <span>查看全部</span>
                </div>
                <div class="msg-list-content">
                    <ul class="relative mt10">
                        <li class="flex column jcb aic fs14 wp mb15"
                            v-for="item in msgList" :key="item.date">
                            <div class="flex jcb wp">
                                <span>{{item.date}}{{item.time}}</span>
                                <span class="fs12">{{item.content}}</span>
                            </div>
                            <div class="flex wp mt10">
                                <span v-show="item.isLive" class="msg-live">直播</span>
                                <p class="fs12 ml10">
                                    <span>{{item.host}}</span>
                                    <span class="ml10">{{item.zc}}</span>
                                    <span class="ml5 mr5">|</span>
                                    <span>{{item.ks}}</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  export default {
    name: "education-search-form",
    props: {
      // value: {
      //   type: Object,
      //   default: () => {
      //     return {}
      //   }
      // },
    },
    data() {
      return {
        msgList:[
          {
            date:"明天",
            time:"9:00",
            host:"江小白",
            zc:"主任医师",
            ks:"肿瘤外科",
            content:"病历分享：溃疡性结肠炎和克罗...",
            id:1,
            isLive:true
          },
          {
            date:"明天",
            time:"9:00",
            host:"江小白",
            zc:"主任医师",
            ks:"肿瘤外科",
            content:"病历分享：溃疡性结肠炎和克罗...",
            id:2,
            isLive:false
          },
          {
            date:"明天",
            time:"9:00",
            host:"江小白",
            zc:"主任医师",
            ks:"肿瘤外科",
            content:"病历分享：溃疡性结肠炎和克罗...",
            id:3,
            isLive:true
          },
          {
            date:"明天",
            time:"9:00",
            host:"江小白",
            zc:"主任医师",
            ks:"肿瘤外科",
            content:"病历分享：溃疡性结肠炎和克罗...",
            id:4,
            isLive:true
          },
          {
            date:"明天",
            time:"9:00",
            host:"江小白",
            zc:"主任医师",
            ks:"肿瘤外科",
            content:"病历分享：溃疡性结肠炎和克罗...",
            id:5,
            isLive:true
          },
          {
            date:"明天",
            time:"9:00",
            host:"江小白",
            zc:"主任医师",
            ks:"肿瘤外科",
            content:"病历分享：溃疡性结肠炎和克罗...",
            id:6,
            isLive:true
          },
        ],
      }
    },
  }
</script>

<style scoped>
    @keyframes rowup {
        0% {
            transform: translate3d(0, 0, 0);
        }
        100% {
            transform: translate3d(0, -35px, 0);
        }
    }
    .banner-wrap {
        width: 100%;
        height: 296px;
        margin: 0 auto;
        position: relative;
        background-image: url("../../assets/icon/education/banner.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .msg-list {
        width: 296px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 90px;
        background-color: #172B43;
        opacity: 0.7;
        padding: 20px 10px 30px;
        box-sizing: border-box;
    }
    .msg-list-content{
        height: 100%;
        overflow: hidden;
    }
    .msg-live{
        display: inline-block;
        width: 40px;
        height: 18px;
        border: 1px solid #FCA03A;
        border-radius: 8.5px;
        color: #FCA03A;
        text-align: center;
        font-size: 12px;
    }
    .wp{
        width:100%;
    }



</style>